import { useMemo } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function useBudget() {
  const user = useAuthStore((s) => s.user);

  const budgetInfo = useMemo(() => {
    if (!user) {
      return {
        percentage: 0,
        used: 0,
        limit: 100,
        status: 'normal' as const,
        color: 'bg-emerald-500',
        textColor: 'text-emerald-500',
      };
    }

    const used = user.budgetUsed || 0;
    const limit = user.budgetLimit || 100;
    const percentage = Math.min(100, Math.round((used / limit) * 100));

    let status: 'normal' | 'warning' | 'danger' = 'normal';
    let color = 'bg-emerald-500';
    let textColor = 'text-emerald-500';

    if (percentage >= 100) {
      status = 'danger';
      color = 'bg-red-500';
      textColor = 'text-red-500';
    } else if (percentage >= 80) {
      status = 'warning';
      color = 'bg-amber-500';
      textColor = 'text-amber-500';
    }

    return { percentage, used, limit, status, color, textColor };
  }, [user]);

  return budgetInfo;
}
